import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useEffect } from 'preact/hooks'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'

export function useFilterScroll() {
  const { options } = useAthosContext()
  const filters = options.get('filters')
  const sorts = options.get('sort')
  const { setNode: setScrollElement, entry: scrollStartElement } = useIntersectionObserver({ threshold: 0.05 })

  useEffect(() => {
    if (scrollStartElement?.isIntersecting === false || scrollStartElement?.boundingClientRect?.top < window.scrollY) {
      const offset = 50
      const scrollToPosition = scrollStartElement?.boundingClientRect?.top - offset
      window.scrollTo({ top: scrollToPosition, behavior: 'instant' })
    }
  }, [filters, sorts])

  return { setScrollElement }
}
